import { createAsyncThunk } from '@reduxjs/toolkit';
import { examApi } from '~/apis/exam';
import { CREATE_EXAM, GET_LIST_EXAM } from '~/utils/constants/actionType';
import { IBodyCreateExam, IQueryGetExams } from '~/utils/interface/exam';

export const getListExams = createAsyncThunk(GET_LIST_EXAM, async (payload: IQueryGetExams, { rejectWithValue }) => {
  try {
    const res = await examApi.getListExams(payload);
    return res.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createExam = createAsyncThunk(CREATE_EXAM, async (payload: IBodyCreateExam, { rejectWithValue }) => {
  try {
    const res = await examApi.createExam(payload);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
